export const restUrl = process.env.NODE_ENV === 'production' ? 'proUrl' : 'http://localhost:3005'